import { Link } from 'react-router-dom'
import ClickProLogo from './ClickProLogo'

const FOOTER_SECTIONS = [
  {
    title: 'Navigation',
    links: [
      { href: 'https://clicketpro.fr', label: 'Accueil' },
      { href: 'https://clicketpro.fr/artisans', label: 'Artisans' },
      { to: '/demandes', label: 'Demandes' },
      { href: 'https://clicketpro.fr/emplois', label: "Offres d'emploi" },
    ],
  },
  {
    title: 'Outils',
    links: [
      { href: 'https://clicketpro.fr/outils/simulateur-aides-renovation', label: 'Simulateur d’aides rénovation' },
      { href: 'https://clicketpro.fr/outils/simulateur-pret-travaux', label: 'Simulateur prêt travaux' },
      { href: 'https://clicketpro.fr/outils/calculateur-charges-auto-entrepreneur', label: 'Charges auto-entrepreneur' },
      { href: 'https://clicketpro.fr/outils/simulateur-eco-ptz', label: 'Simulateur Éco-PTZ' },
      { href: 'https://clicketpro.fr/outils/estimateur-gain-energetique', label: 'Estimateur de gain énergétique' },
      { href: 'https://clicketpro.fr/outils/calculateur-duree-chantier', label: 'Calculateur durée chantier' },
      { to: '/deposer-demande', label: 'Déposer une demande' },
    ],
  },
  {
    title: 'À propos',
    links: [
      { href: '#', label: 'Qui sommes-nous ?' },
      { href: '#', label: 'Comment ça marche ?' },
      { href: 'https://clicketpro.fr/contact', label: 'Contact' },
    ],
  },
  {
    title: 'Légal',
    links: [
      { href: 'https://clicketpro.fr/politique-confidentialite', label: 'Politique de confidentialité' },
      { href: 'https://clicketpro.fr/cgv', label: 'CGU-CGV' },
    ],
  },
]

const SocialIcon = ({ href, label, children }) => (
  <a
    href={href}
    aria-label={label}
    className="w-10 h-10 rounded-full bg-muted flex items-center justify-center text-muted-foreground hover:bg-primary hover:text-white transition-all duration-500 ease-lux"
  >
    {children}
  </a>
)

export default function PublicFooter() {
  return (
    <footer className="bg-card border-t border-border py-16 md:py-20 lg:py-24 mt-auto" data-testid="footer">
      <div className="container-clickpro">
        <div className="grid md:grid-cols-6 gap-10 md:gap-12 lg:gap-16 mb-12 md:mb-16">
          <div className="md:col-span-2">
            <ClickProLogo className="mb-6" />
            <p className="text-muted-foreground text-sm md:text-base max-w-sm leading-relaxed">
              La mise en relation simple entre clients et professionnels.
            </p>
            <div className="flex gap-3 mt-8">
              <SocialIcon href="#" label="Twitter">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                </svg>
              </SocialIcon>
              <SocialIcon href="#" label="Instagram">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </SocialIcon>
              <SocialIcon href="#" label="LinkedIn">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                </svg>
              </SocialIcon>
            </div>
          </div>

          {FOOTER_SECTIONS.map(({ title, links }) => (
            <div key={title}>
              <h4 className="font-display font-semibold text-foreground mb-5">{title}</h4>
              <ul className="space-y-3 text-sm md:text-base text-muted-foreground">
                {links.map(({ to, href, label }) => (
                  <li key={label}>
                    {to ? (
                      <Link to={to} className="hover:text-primary transition-colors duration-300">
                        {label}
                      </Link>
                    ) : (
                      <a href={href} className="hover:text-primary transition-colors duration-300">
                        {label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-border pt-10 text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Click&Pro. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  )
}
